import { ROUTE_NAMES } from '@/lib/enums';

export const routes = [
	{
		path: 'sites',
		redirect: { name: ROUTE_NAMES.DEPOT.SITES.OVERVIEW },
		meta: {
			requireAuth: true,
			breadcrumb: 'Sites',
		},
		children: [
			{
				path: 'overview',
				name: ROUTE_NAMES.DEPOT.SITES.OVERVIEW,
				component: () => {
					return import('@/views/depot/sites/Overview.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Sites',
					breadcrumb: 'Overview',
				},
			},
			{
				path: 'search',
				name: ROUTE_NAMES.DEPOT.SITES.SEARCH,
				component: () => {
					return import('@/views/depot/sites/Search.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Site Search',
					breadcrumb: 'Search',
				},
			},
		],
	},
];
